import { useParams } from 'react-router';

const EditCategory = () => {
	const { categoryId } = useParams();
	return `EditCategory id=${categoryId} -- this feature is planned for the version 1 release...`;
};

export default EditCategory;
